import http from '@/utils/api';

export function downloadFile(href, name = '') {
  const anchor = document.createElement('a');
  anchor.href = href;
  anchor.download = name;

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

export function downloadBlobFile(data, fileName = '') {
  const fileUrl = URL.createObjectURL(data);
  downloadFile(fileUrl, fileName);
  URL.revokeObjectURL(data);
}

export function downloadFileWithBlob(data, type, fileName = '') {
  const dataList = [];
  if (type === 'data:text/csv' || type === 'text/csv') {
    dataList.push(new Uint8Array([0xEF, 0xBB, 0xBF])); // UTF-8 BOM
  }
  dataList.push(data);
  const blob = new Blob(dataList, { type });
  downloadBlobFile(blob, fileName);
}

export async function openFile(attachmentPath) {
  try {
    const response = await http.get(attachmentPath, { responseType: 'blob' });
    window.open(URL.createObjectURL(response), '_blank');
  } catch (e) {
    console.error(e);
  }
}

export async function fetchAndGetURL(path) {
  try {
    const response = await http.get(path, { responseType: 'blob' });
    return URL.createObjectURL(response);
  } catch (e) {
    console.error(e);
  }
}
